import { lazy } from 'react';
import type { AppManifest } from '@shared/app/types';

export const manifest: AppManifest = {
  uuid: '9b50e026-b2d6-4683-84c7-b5bcf913c315',
  name: 'Meeting',
  slug: 'meeting',
  icon: 'GroupsOutlined',
  core: true,
  enabled: true,
  type: 'local',
  base: '@apps/meeting', // This should match the moduleRegistry key
  entry: 'App',
  views: [
    {
      slug: 'placeholder',
      label: 'Placeholder View',
      component: lazy(() => import('./views/PlaceholderView')),
    },
    {
      slug: 'default',
      label: 'Default View',
      component: lazy(() => import('./views/DefaultView')),
    },
    {
      slug: 'screen-share',
      label: 'Screen Share Carousel',
      component: lazy(() => import('./views/ScreenShareCarouselView')),
    },
    {
      slug: 'participants-grid',
      label: 'Participants Grid',
      component: lazy(() => import('./views/ParticipantsGridView')),
    },
    {
      slug: 'overlay',
      label: 'Overlay',
      component: lazy(() => import('./views/MeetingOverlayView')),
    },
  ],
  settings: [
    {
      slug: 'settings',
      label: 'Default Settings',
      component: lazy(() => import('./views/settings/MeetingSettings')),
    },
  ],
  admin: [],
  reports: [],
};
export default manifest;
